import { z } from 'zod';
import { authAccountSchema } from './auth-account.schema';
import { authUserSchema } from './auth-user.schema';

const multiAccountAuthResponseSchema = z.object({
  accounts: z.array(authAccountSchema),
  status: z.literal('FailedToLoginDueToMultipleAccounts'),
});

const expiredAccountAuthResponseSchema = z.object({
  status: z.literal('FailedToLoginAccountExpired'),
  userInfo: authUserSchema,
});

const invalidTidTokenAuthResponseSchema = z.object({
  status: z.literal('FailedToValidateTrimbleIdentityToken'),
});

export const authenticateResponseSchema = z.union([
  authUserSchema,
  multiAccountAuthResponseSchema,
  expiredAccountAuthResponseSchema,
  invalidTidTokenAuthResponseSchema,
]);
